module.exports = __webpack_public_path__ + "static/img/weixin.8c0420f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin.jpg
// module id = AVi7
// module chunks = 1